import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { SubNavigationItemProps } from "../components/Navigation/SubNavigationItems";

export const useSubNavigationRedirect = (items: SubNavigationItemProps[]) => {
	const history = useHistory();

	useEffect(() => {
		handleSubNavigationRedirect();
	}, []);

	const handleSubNavigationRedirect = () => {
		const currentItem = items.find(
			(item) =>
				item.route === location.pathname ||
				location.pathname.includes(item.route) ||
				item.route.includes(location.pathname)
		);
		if (currentItem && currentItem.hide) redirectToFirstVisibleItem();
	};

	const redirectToFirstVisibleItem = () => {
		const visibleNavigationItems = items.filter((item) => !item.hide);
		const firstVisibleNavigationItem = visibleNavigationItems[0];
		if (firstVisibleNavigationItem) {
			history.replace(firstVisibleNavigationItem.route);
		}
	};
};
